import { Skeleton } from '~/shadcn/ui/skeleton'
import { useProjectMedium } from './useProjectMedium'

type Props = {
  projectId: string
  filename: string
  children(blob: Blob): React.ReactNode
}

function ProjectMedium({ projectId, filename, children }: Props) {
  const { data, isLoading, error } = useProjectMedium(projectId, filename)
  if (isLoading)
    return (
      <Skeleton className="absolute bg-gray-600 w-full h-full inset-0 rounded-[5px] pointer-events-none" />
    )
  if (error) return <div>Error: {error.message}</div>
  if (!data) return <div>No data</div>

  return <>{children(data)}</>
}

export { ProjectMedium }
